/* @flow */

export const MARK_APP_AS_EMBEDDED = 'MARK_APP_AS_EMBEDDED';
export const MARK_APP_AS_NOT_EMBEDDED = 'MARK_APP_AS_NOT_EMBEDDED';
